import { connect } from 'react-redux';

import BuySMS from './BuySMS';
import { setAmount, createPaymentIntent } from './actions';
import { withRouter } from 'react-router-dom';
import { openSnackbar } from '../../../../app/modules/snackbar/actions';
const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  ...state.account.buySMS,
  profile: state.account.profile,
  intl: state.account.intl,
  integration: state.account.organisation.integration,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setAmount: integration =>
    dispatch(setAmount(ownProps.location.query, integration)),
  handleCharge: (stripe, cost, metadata) =>
    dispatch(createPaymentIntent(stripe, cost, metadata)),
  displayPaymentError: msg => dispatch(openSnackbar(msg)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BuySMS));
